export default __webpack_public_path__ + "a01518b297581a26cd9799d780668ce2.svg";